import { Component, OnInit, Inject } from '@angular/core';
import { SchematicViewService } from './schematic-view.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SchematicDataVM } from './schematic-view';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-schematic-view',
    templateUrl: './schematic-view.component.html',
    styleUrls: ['./schematic-view.component.css']
})
export class SchematicViewComponent implements OnInit {
    implementId: number;
    schematics: SchematicDataVM[];

    constructor(private dialogRef: MatDialogRef<SchematicViewComponent>,
        private _svService: SchematicViewService, private _sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: any) {

    }

    ngOnInit() {
        if (this.data.implementId != null) {
            this.implementId = this.data.implementId;
        }

        this._svService.GetSchematicDataForImplement(this.implementId).subscribe(res => {
            if (res != null) {
                this.schematics = res;
            }

        }, error => { console.log(error); });
    }

    getImage(image: string) {
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }

    getPosition(posX: string, posY: string) {
        return this._sanitizer.bypassSecurityTrustStyle('Left: ' + posX + 'px;' + 'Top: ' + posY + 'px;'
            + 'Position: absolute; margin-top: 4px; margin-bottom: 4px;');
    }

    getEval(wornPct: number, inspectDate: string) {
        if ((wornPct == 0) && (inspectDate == "Never")) {
            return 'gray';
        } else if (wornPct <= 30) {
            return 'green';
        } else if ((wornPct > 30) && (wornPct <= 60)) {
            return 'yellow';
        } else if ((wornPct > 60) && (wornPct <= 80)) {
            return 'orange';
        } else if (wornPct > 80) {
            return 'red';
        }
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
}
